import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexContainer } from '../../styled/layout.styled';

const StyledTabHeader = styled(FlexContainer)`
  width: 100%;
  border-bottom: 1px solid rgba(199, 186, 241, 0.2);
  margin-bottom: 4px;
`;
const StyledTabTitle = styled.p`
  cursor: pointer;
  padding-bottom: 4px;
  margin-right: 40px;
  display: inline-block;
  position: relative;
  color: ${({ visited }) => (visited ? '#ff2976' : '#6e658a')};
  transition: all 0.3s ease-in;
  &:hover {
    color: ${({ visited }) => (visited ? '' : ' #c7baf1')};
  }
  &:after {
    content: '';
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: -1px;
    display: block;
    background-color: ${({ visited }) => (visited ? '#ff2976' : '')};
    transition: all 0.3s ease-in;
  }
`;

const Tabs = ({ tabTitles, selectedTab, setSelectedTab }) => (
  <>
    <StyledTabHeader>
      {tabTitles.map(title => (
        <StyledTabTitle
          visited={selectedTab === title}
          key={title}
          onClick={() => setSelectedTab(title)}
          className="xlarge"
        >
          {title}
        </StyledTabTitle>
      ))}
    </StyledTabHeader>
  </>
);

Tabs.propTypes = {
  tabTitles: PropTypes.array.isRequired,
  selectedTab: PropTypes.string.isRequired,
  setSelectedTab: PropTypes.func.isRequired,
};

export default Tabs;
